import React, { FC, useState, useEffect } from 'react'
import styled from 'styled-components'

export const Header = styled.div<{ $scrolled?: boolean }>`
  position: fixed;
  width: 100%;
  height: 70px;
  background-color: ${(props) => (props.$scrolled ? 'white' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 0px;
  left: 0px;
  padding: 0 30px;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: ${(props) =>
    props.$scrolled ? '0px 2px 10px rgba(0, 0, 0, 0.1)' : 'none'};
`

export const TextLogo = styled.div`
  cursor: pointer;
  text-decoration: none;
  color: #4c5197;

  /* Paragraph 1 - Regular */
  font-family: Inter;
  font-size: var(--Fonts-Size-Paragraph-1, 20px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Fonts-Line-height-Paragraph-1, 30px); /* 150% */
  letter-spacing: -0.5px;

  span {
    color: #c779de;

    /* Paragraph 1 - Regular */
    font-family: Inter;
    font-size: var(--Fonts-Size-Paragraph-1, 20px);
    font-style: normal;
    font-weight: 700;
    line-height: var(--Fonts-Line-height-Paragraph-1, 30px);
    letter-spacing: -0.5px;
  }
`

export const HeaderMobile: FC = () => {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      // Change state when scroll position is greater than a threshold (e.g., 50px)
      const isScrolled = window.scrollY > 50
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled)
      }
    }

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll)

    // Initial check
    handleScroll()

    // Clean up event listener
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [scrolled])

  return (
    <Header $scrolled={scrolled}>
      <TextLogo onClick={() => window.location.replace('/')}>
        Sample<span>Bank</span>
      </TextLogo>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.375 8.91593C4.375 8.47911 4.73246 8.125 5.17341 8.125L24.8266 8.125C25.2675 8.125 25.625 8.47911 25.625 8.91593C25.625 9.35275 25.2675 9.70686 24.8266 9.70686L5.17341 9.70686C4.73246 9.70686 4.375 9.35275 4.375 8.91593ZM4.375 15C4.375 14.5632 4.73246 14.2091 5.17341 14.2091L24.8266 14.2091C25.2675 14.2091 25.625 14.5632 25.625 15C25.625 15.4368 25.2675 15.7909 24.8266 15.7909L5.17341 15.7909C4.73246 15.7909 4.375 15.4368 4.375 15ZM4.375 21.0841C4.375 20.6473 4.73246 20.2931 5.17341 20.2931L24.8266 20.2931C25.2675 20.2931 25.625 20.6473 25.625 21.0841C25.625 21.5209 25.2675 21.875 24.8266 21.875L5.17341 21.875C4.73246 21.875 4.375 21.5209 4.375 21.0841Z"
          fill="#2C3069"
        />
      </svg>
    </Header>
  )
}
